import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import LazyLoad from 'react-lazyload'
import ContactRequestButton from '~/components/LandingPage/components/ContactRequestButton'
import FeatureBlock from '~/components/LandingPage/components/FeatureBlock/FeatureBlock'
import HeroBanner from '~/components/LandingPage/HeroBanner'
import JourneySection from '~/components/LandingPage/JourneySection'
import TeamSection from '~/components/LandingPage/TeamSection'
import LayoutLandingPage from '~/components/Layout/LayoutLandingPage'

const LazyLoadWrapper = LazyLoad as unknown as FC<any>

const AttractAndSourceContainer: FC = () => {
  const { t } = useTranslation()

  return (
    <LayoutLandingPage>
      <HeroBanner
        badgeLabel={t('attract_n_source:label')}
        badgeColor="bg-yellow-100 text-yellow-800"
        title={t('attract_n_source:title')}
        description={t('attract_n_source:description')}
        images={{
          desktop: '/img/feature/lp/d-attract-and-source-hero.png',
          mobile: '/img/feature/lp/m-attract-and-source-hero-mweb.png'
        }}
        imageClassName="tablet:w-1/2 tablet:right-0"
      />

      {/* Feature 1 */}
      <LazyLoadWrapper height={500} once>
        <FeatureBlock
          className="mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0"
          title={t('attract_n_source:enhance_and_engagement')}
          description={t('attract_n_source:enhance_and_engagement_description')}
          openLink={<ContactRequestButton />}
          image={
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet="/img/feature/lp/attract-source-feature-1-desk.png"
              />
              <source
                media="(max-width: 767px)"
                srcSet="/img/feature/lp/attract-source-feature-1-mweb.png"
              />
              <img alt="Enhance employer brand and engagement" loading="lazy" />
            </picture>
          }
        />
      </LazyLoadWrapper>

      {/* Feature 2 */}
      <LazyLoadWrapper height={500} once>
        <FeatureBlock
          className="mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0"
          title={t('attract_n_source:post_job_on_other_boards')}
          description={t(
            'attract_n_source:post_job_on_other_boards_description'
          )}
          textPosition="right"
          openLink={<ContactRequestButton />}
          image={
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet="/img/feature/lp/attract-source-feature-2-desk.png"
              />
              <source
                media="(max-width: 767px)"
                srcSet="/img/feature/lp/attract-source-feature-2-mweb.png"
              />
              <img alt="Enhance employer brand and engagement" loading="lazy" />
            </picture>
          }
        />
      </LazyLoadWrapper>

      {/* Feature 3 */}
      <LazyLoadWrapper height={500} once>
        <FeatureBlock
          className="mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0"
          title={t('attract_n_source:bring_your_team_into_sourcing')}
          description={t(
            'attract_n_source:bring_your_team_into_sourcing_description'
          )}
          textPosition="left"
          openLink={<ContactRequestButton />}
          image={
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet="/img/feature/lp/attract-source-feature-3-desk.png"
              />
              <source
                media="(max-width: 767px)"
                srcSet="/img/feature/lp/attract-source-feature-3-mweb.png"
              />
              <img alt="Enhance employer brand and engagement" loading="lazy" />
            </picture>
          }
        />
      </LazyLoadWrapper>

      {/* Feature 4 */}
      <LazyLoadWrapper height={500} once>
        <FeatureBlock
          className="mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0"
          title={t('attract_n_source:keep_communication_in_one_place')}
          description={t(
            'attract_n_source:keep_communication_in_one_place_description'
          )}
          textPosition="right"
          openLink={<ContactRequestButton />}
          image={
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet="/img/feature/lp/attract-source-feature-4-desk.png"
              />
              <source
                media="(max-width: 767px)"
                srcSet="/img/feature/lp/attract-source-feature-4-mweb.png"
              />
              <img alt="Enhance employer brand and engagement" loading="lazy" />
            </picture>
          }
        />
      </LazyLoadWrapper>

      {/* Feature 5 */}
      <LazyLoadWrapper height={500} once>
        <FeatureBlock
          className="mt-[64px] mb-0 desktop:mt-[140px] desktop:mb-0"
          title={t('attract_n_source:effortlessly_schedule_interview')}
          description={t(
            'attract_n_source:effortlessly_schedule_interview_description'
          )}
          textPosition="left"
          openLink={<ContactRequestButton />}
          image={
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet="/img/feature/lp/attract-source-feature-5-desk.png"
              />
              <source
                media="(max-width: 767px)"
                srcSet="/img/feature/lp/attract-source-feature-5-mweb.png"
              />
              <img alt="Enhance employer brand and engagement" loading="lazy" />
            </picture>
          }
        />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={500} once>
        <TeamSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={500} once>
        <JourneySection className="desktop:mt-[140px] desktop:mb-[0px] bg-gray-50 mt-[64px] my-[0px] py-[64px]" />
      </LazyLoadWrapper>
    </LayoutLandingPage>
  )
}

export default AttractAndSourceContainer
